import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/compass': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M347.9 129.9L203.6 195.8A31.9-31.9 0 0 1 187.8 211.6L121.9 355.9C114.3 372.6 131.4 389.8 148.1 382.1L292.4 316.2A31.9-31.9 0 0 1 308.2 300.4L374.1 156.1C381.8 139.4 364.6 122.3 347.9 129.9zM270.6 278.6C258.1 291.1 237.9 291.1 225.4 278.6 212.9 266.1 212.9 245.9 225.4 233.4 237.9 220.9 258.1 220.9 270.6 233.4 283.1 245.9 283.1 266.1 270.6 278.6zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/compass.js
// module id = Bz6O
// module chunks = 144